import React, { useContext, useEffect, useState } from 'react';
import { Carrier, defaultCarrier } from '../../../app/models/Carrier';
import useCarrierService from '../../../app/services/hooks/useCarrierService';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import CarrierFormContainer from './CarrierFormContainer';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';

interface Props {
    CarrierId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const CarrierEdit = ({ CarrierId, onSaved, onCancel, onError }: Props) => {
    const { fetchingEditCarrier, editCarrier, fetchingUpdateCarrier, updateCarrier } =
        useCarrierService();

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [Carrier, setCarrier] = useState<Carrier>(defaultCarrier);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        editCarrier(CarrierId, {
            onSuccess: (response: ServiceResponse) => {
                setCarrier(response.data.carrier);
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        updateCarrier(CarrierId, Carrier, {
            onSuccess: () => {
                if (onSaved) onSaved();
            },
            onError: () => {
                if (onError) onError();
            },
            onFieldError: (errorFields: ServiceResponse) => {
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditCarrier ? (
        <LazyLoading height="300" />
    ) : (
        <CarrierFormContainer
            fetching={fetchingUpdateCarrier}
            action={update}
            cancel={cancel}
            Carrier={Carrier}
            setCarrier={setCarrier}
            errorFields={errorFields}
        />
    );
};

export default CarrierEdit;
